import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Clients } from '../components/Clients';
import { Team } from '../components/Team';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-197">
      <Navbar data-id="element-198" />
      <Hero data-id="element-199" />
      <Services data-id="element-200" />
      <Process data-id="element-201" />
      <Clients data-id="element-202" />
      <Team data-id="element-203" />
      <FAQ data-id="element-204" />
      <CTASection data-id="element-205" />
      <ContactForm data-id="element-206" />
      <Footer data-id="element-207" />
    </div>;
}